import imgEverWallet from '@/assets/icons/currency.svg';
export const currencyName = 'MSHA';
export const currencyImg = imgEverWallet;

export const networkId = 10000001;
